import axios from "axios";
import {
  AuthCodeRequest, AuthCodeResponse, AuthCodeMailRequest
} from "@/api/dto/AuthCode"


/**
 * 認証コードを検証する
 * @param req 認証コード検証リクエスト
 * @returns 検証結果レスポンス
 */
export const validateAuthCode = async (req: AuthCodeRequest): Promise<AuthCodeResponse> => {
  const res = await axios.post<AuthCodeResponse>(`/api/user/validate/authCode`, req)
  return res.data;
};

/**
 * メールアドレスによって認証コードを検証する
 * @param req 認証コード検証リクエスト
 * @returns 検証結果レスポンス
 */
export const validateAuthCodeMail = async (req: AuthCodeMailRequest): Promise<AuthCodeResponse> => {
  const res = await axios.post<AuthCodeResponse>(`/api/user/validate/mailAuthCode`, req)
  return res.data;
};